import axios from './axios';

export default {
  // Promozioni attive nel loro intervallo di validità
  getAll: async () => {
    const url = `${process.env.REACT_APP_API_URL}/promotionPost`;
    return await axios.get(url);
  },
};
